import MuiThemeProvider from "components/MuiThemeProvider";
import LocaleProvider from "providers/LocaleProvider";
import SWRConfigProvider from "providers/SWRConfigProvider";
import UserProvider from "providers/UserProvider";
import InfoMessageProvider from "providers/InfoMessageProvider";

interface GlobalProvidersProps {
  children: React.ReactNode;
}

/**
 * GlobalProviders is a wrapper component that provides global context providers
 * for the application. It includes providers for theming, locale, SWR configuration,
 * user authentication, and initial loading state management.
 */
function GlobalProviders(props: GlobalProvidersProps) {
  return (
    <SWRConfigProvider>
      <LocaleProvider>
        <MuiThemeProvider>
          <InfoMessageProvider>
            <UserProvider>
              <>{props.children}</>
            </UserProvider>
          </InfoMessageProvider>
        </MuiThemeProvider>
      </LocaleProvider>
    </SWRConfigProvider>
  );
}
export default GlobalProviders;
